import React from "react";

export const Remoto = (props) => {
  return (
    <div id="remoto">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/cellphone.png" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="remoto-text">
              <h2>Dispositivos Inteligentes "Remoto"</h2>
              <p>{props.data ? props.data.paragraph : "Carregando..."}</p>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "Carregando..."}
                  </ul>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
